<template>
    <div class="df">
        <Form ref="form" :label-width="100" :rules="innerRules">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="交租方式" prop="payMethod">
                        <demo-pay-method></demo-pay-method>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="费用列表" prop="feeList">
                        <demo-fee-list></demo-fee-list>
                    </FormItem>
                </Col>
            </Row>
            <!-- 操作 -->
            <div style="margin-top: 20px">
                <Button
                    type="primary"
                    style="margin-right: 10px"
                    @click="onValidate"
                    >校验</Button
                >
                <Button type="info" @click="onSave">保存</Button>
            </div>
        </Form>
    </div>
</template>
<script>
import DemoFeeList from './components/demo-fee-list'
import DemoPayMethod from './components/demo-pay-method'

export default {
    name: 'demo-composit-form',
    components: {
        DemoFeeList,
        DemoPayMethod,
    },
    data() {
        return {
            feeList: [],
            payMethod: {
                pledge: '',
                pay: '',
            },
        }
    },
    computed: {
        innerRules() {
            return {
                feeList: {
                    startTime: [{ validator: this.checkEndTime }],
                    endTime: [{ validator: this.checkEndTime }],
                    amount: [
                        { required: true, message: '优惠金额必填' },
                        { validator: this.checkAmount },
                    ],
                },
                payMethod: {
                    pledge: [{ required: true, message: '必填' }],
                    pay: [{ required: true, message: '必填' }],
                },
            }
        },
    },
    methods: {
        // 校验
        onValidate() {
            this.$refs.form.validate().then(() => {
                console.log('成功')
            })
        },
        // 保存
        onSave() {
            console.log(JSON.stringify(this.$refs.form.populateData(), null, 4))
        },
        //
        checkEndTime(rule, value, callback, source, options) {
            if (source.startTime && source.endTime) {
                if (source.endTime.getTime() < source.startTime.getTime()) {
                    callback(new Error('开始日期不能大于截止日期'))
                }
            }
            callback()
        },
        //
        checkAmount(rule, value, callback, source, options) {
            if (value > 10) {
                return callback()
            }
            callback(new Error('金额必须大于10'))
        },
    },
}
</script>
<style lang="less" scoped>
.df {
    padding: 20px;
}
</style>
